<template>
	<div class="google-map-wrapper">
		<label><b>Click map or drag marker to set latitude and longitude automatically</b></label>
		<div class="google-map-panel" v-if="showPanel">
			<h2>Search and add a pin</h2>
			<label>
				<gmap-autocomplete
					class="form-control"
					@place_changed="setPlace">
				</gmap-autocomplete>
				<button
					class="btn btn-default"
					@click="addMarker(currentPlace)"
					v-if="currentPlace">
					Add
				</button>
			</label>
			<br/>
		</div>
		<gmap-map
			class="google-map"
			:center="center"
			:zoom="zoom"
			@click="updatePlace"
		>
			<gmap-marker
				:position="place"
				:draggable="true"
				@dragend="updatePlace"
				@click="center=place"
				v-if="place"
			></gmap-marker>
			<gmap-marker
				:key="index"
				v-for="(m, index) in markers"
				:position="m.position"
				@click="center=m.position"
			></gmap-marker>
		</gmap-map>
	</div>
</template>

<script>
export default {
	name: 'GoogleMap',
	props: {
		showPanel: {
			type: Boolean,
			default: false,
		},
		lat: {},
		lng: {},
	},
	data() {
		return {
			zoom: 14,
			// default to Bandung
			center: { lat: -6.914744, lng: 107.609810 },
			markers: [],
			places: [],
			currentPlace: null,
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		// receives a place object via the autocomplete component
		setPlace(place) {
			this.currentPlace = place;
		},
		addMarker(place) {
			const marker = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
			};
			this.markers.push({ position: marker });
			this.places.push(place);
			this.center = marker;
		},
		init() {
			if (this.lat && this.lng) {
				this.center = { lat: this.lat, lng: this.lng };
			} else {
				this.geolocate();
			}
		},
		geolocate() {
			const successCallback = (position) => {
				this.center = {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				};
			};
			navigator.geolocation.getCurrentPosition(successCallback);
		},
		updatePlace(place) {
			const marker = {
				lat: place.latLng.lat(),
				lng: place.latLng.lng(),
			};
			this.center = marker;
			this.$emit('update:lat', marker.lat);
			this.$emit('update:lng', marker.lng);
		},
	},
	computed: {
		place() {
			const place = this.lat && this.lng ? { lat: parseFloat(this.lat), lng: parseFloat(this.lng) } : null;
			return place;
		},
	},
};
</script>

<style lang="scss">
	.google-map-wrapper {
		margin-bottom: 1.5em;
	}
	.google-map {
		width: 100%;
		height: 400px;
	}
</style>
